import React from 'react';

import './index.scss';

const LoadingPage = ({ title }) => {
  return <div className="loading-page-wrapper">Loading...</div>;
};

export default LoadingPage;
